import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

// Este hook já está exportado pelo AuthContext, mas criando uma versão standalone também
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};